import React, { useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { STATUS_COLORS } from '../statusPalette' // LAP — palette unifiée
import urls from 'utils/urls'
import { makeGetRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function Chart3({ tasks, handleMesTaches, updateTodo }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [loadingDone, setLoadingDone] = useState(false)
  const optionsbar = {
    indexAxis: 'y',
    responsive: true,
    aspectRatio: 1,
    maintainAspectRatio: false,

    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        position: 'bottom',
        // LAP — libellés lisibles sur fond sombre, pastilles rondes
        labels: { color: 'white', usePointStyle: true, pointStyle: 'circle', boxWidth: 8 },
      },
      // tooltips: {
      //   callbacks: {
      //     label: function (tooltipItem) {
      //       return tooltipItem.yLabel
      //     },
      //     title: () => null,
      //   },
      // },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: 'white' },
      },
      y: {
        stacked: true,
        ticks: { color: 'white' },
      },
    },
  }

  const [data, setRevData] = useState({
    labels: [t('mesToDo.filterToday'), t('mesToDo.filterImportant'), t('mesToDo.filterUpcoming'), t('mesToDo.filterAnytime'), t('mesToDo.filterUnclassified')],
    datasets: [
      {
        label: t('mesToDo.statusNotStartedAlt'),
        data: [0, 0, 0, 0, 0],
        backgroundColor: [STATUS_COLORS.notStarted],
        borderColor: [STATUS_COLORS.notStarted],
        barThickness: 20,
        borderRadius: 4,
      },
      {
        label: t('mesToDo.statusInProgressAlt'),
        data: [0, 0, 0, 0, 0],
        backgroundColor: [STATUS_COLORS.inProgress],
        borderColor: [STATUS_COLORS.inProgress],
        barThickness: 20,
        borderRadius: 4,
      },
      {
        label: t('mesToDo.statusLateAlt'),
        data: [0, 0, 0, 0, 0],
        backgroundColor: [STATUS_COLORS.late],
        borderColor: [STATUS_COLORS.late],
        barThickness: 20,
        borderRadius: 4,
      },
      {
        label: t('mesToDo.statusCompletedAlt'),
        data: [0, 0, 0, 0, 0],
        backgroundColor: [STATUS_COLORS.done],
        borderColor: [STATUS_COLORS.done],
        barThickness: 20,
        borderRadius: 4,
      },
    ],
  })

  const [tasks1, setTasks1] = useState([0, 0, 0, 0, 0])
  const [tasks2, setTasks2] = useState([0, 0, 0, 0, 0])
  const [tasks3, setTasks3] = useState([0, 0, 0, 0, 0])
  const [tasks4, setTasks4] = useState([0, 0, 0, 0, 0])

  useEffect(() => {
    getData()
  }, [])
  const getData = async () => {
    setLoadingDone(false)
    await fetchTasks1()
    await fetchTasks2()
    await fetchTasks3()
    await fetchTasks4()
    await fetchTasks5()
    setLoadingDone(true)
  }
  const fetchTasks1 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat1&limit=100',
      {},
      true,
    )
    if (status === 200) {
      updateTodo('cat1', data.results)
      let t1 = 0
      let t2 = 0
      let t3 = 0
      let t4 = 0
      data.results.forEach((v) => {
        if (v.Statut === 'Fait') {
          t4 = t4 + 1
        }
        if (v.Statut === 'En-Cours') {
          t2 = t2 + 1
        }
        if (v.Statut === 'En-retard') {
          t3 = t3 + 1
        }
        if (v.Statut === 'Non démarré') {
          t1 = t1 + 1
        }
      })
      let tt1 = tasks1
      tt1[0] = t1
      setTasks1(tt1)
      let tt2 = tasks2
      tt2[0] = t2
      setTasks2(tt2)
      let tt3 = tasks3
      tt3[0] = t3
      setTasks3(tt3)
      let tt4 = tasks4
      tt4[0] = t4
      setTasks4(tt4)
    }
  }
  const fetchTasks2 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat2&limit=100',
      {},
      true,
    )
    if (status === 200) {
      updateTodo('cat2', data.results)
      let t1 = 0
      let t2 = 0
      let t3 = 0
      let t4 = 0
      data.results.forEach((v) => {
        if (v.Statut === 'Fait') {
          t4 = t4 + 1
        }
        if (v.Statut === 'En-Cours') {
          t2 = t2 + 1
        }
        if (v.Statut === 'En-retard') {
          t3 = t3 + 1
        }
        if (v.Statut === 'Non démarré') {
          t1 = t1 + 1
        }
      })
      let tt1 = tasks1
      tt1[1] = t1
      setTasks1(tt1)
      let tt2 = tasks2
      tt2[1] = t2
      setTasks2(tt2)
      let tt3 = tasks3
      tt3[1] = t3
      setTasks3(tt3)
      let tt4 = tasks4
      tt4[1] = t4
      setTasks4(tt4)
    }
  }
  const fetchTasks3 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat3&limit=100',
      {},
      true,
    )
    if (status === 200) {
      updateTodo('cat3', data.results)
      let t1 = 0
      let t2 = 0
      let t3 = 0
      let t4 = 0
      data.results.forEach((v) => {
        if (v.Statut === 'Fait') {
          t4 = t4 + 1
        }
        if (v.Statut === 'En-Cours') {
          t2 = t2 + 1
        }
        if (v.Statut === 'En-retard') {
          t3 = t3 + 1
        }
        if (v.Statut === 'Non démarré') {
          t1 = t1 + 1
        }
      })
      let tt1 = tasks1
      tt1[2] = t1
      setTasks1(tt1)
      let tt2 = tasks2
      tt2[2] = t2
      setTasks2(tt2)
      let tt3 = tasks3
      tt3[2] = t3
      setTasks3(tt3)
      let tt4 = tasks4
      tt4[2] = t4
      setTasks4(tt4)
    }
  }
  const fetchTasks4 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat4&limit=100',
      {},
      true,
    )
    if (status === 200) {
      updateTodo('cat4', data.results)
      let t1 = 0
      let t2 = 0
      let t3 = 0
      let t4 = 0
      data.results.forEach((v) => {
        if (v.Statut === 'Fait') {
          t4 = t4 + 1
        }
        if (v.Statut === 'En-Cours') {
          t2 = t2 + 1
        }
        if (v.Statut === 'En-retard') {
          t3 = t3 + 1
        }
        if (v.Statut === 'Non démarré') {
          t1 = t1 + 1
        }
      })
      let tt1 = tasks1
      tt1[3] = t1
      setTasks1(tt1)
      let tt2 = tasks2
      tt2[3] = t2
      setTasks2(tt2)
      let tt3 = tasks3
      tt3[3] = t3
      setTasks3(tt3)
      let tt4 = tasks4
      tt4[3] = t4
      setTasks4(tt4)
    }
  }
  const fetchTasks5 = async () => {
    const { data, status } = await makeGetRequest(
      urls.taskOperations + '?task=cat5&limit=100',
      {},
      true,
    )
    if (status === 200) {
      updateTodo('cat5', data.results)
      let t1 = 0
      let t2 = 0
      let t3 = 0
      let t4 = 0
      data.results.forEach((v) => {
        if (v.Statut === 'Fait') {
          t4 = t4 + 1
        }
        if (v.Statut === 'En-Cours') {
          t2 = t2 + 1
        }
        if (v.Statut === 'En-retard') {
          t3 = t3 + 1
        }
        if (v.Statut === 'Non démarré') {
          t1 = t1 + 1
        }
      })
      let tt1 = tasks1
      tt1[4] = t1
      setTasks1(tt1)
      let tt2 = tasks2
      tt2[4] = t2
      setTasks2(tt2)
      let tt3 = tasks3
      tt3[4] = t3
      setTasks3(tt3)
      let tt4 = tasks4
      tt4[4] = t4
      setTasks4(tt4)
    }
  }

  useEffect(() => {
    setRevData({
      labels: [t('mesToDo.filterToday'), t('mesToDo.filterImportant'), t('mesToDo.filterUpcoming'), t('mesToDo.filterAnytime'), t('mesToDo.filterUnclassified')],
      datasets: [
        {
          label: t('mesToDo.statusNotStartedAlt'),
          data: tasks1,
          backgroundColor: [STATUS_COLORS.notStarted],
          borderColor: [STATUS_COLORS.notStarted],
          barThickness: 20,
        borderRadius: 4,
        },
        {
          label: t('mesToDo.statusInProgressAlt'),
          data: tasks2,
          backgroundColor: [STATUS_COLORS.inProgress],
          borderColor: [STATUS_COLORS.inProgress],
          barThickness: 20,
        borderRadius: 4,
        },
        {
          label: t('mesToDo.statusLateAlt'),
          data: tasks3,
          backgroundColor: [STATUS_COLORS.late],
          borderColor: [STATUS_COLORS.late],
          barThickness: 20,
        borderRadius: 4,
        },
        {
          label: t('mesToDo.statusCompletedAlt'),
          data: tasks4,
          backgroundColor: [STATUS_COLORS.done],
          borderColor: [STATUS_COLORS.done],
          barThickness: 20,
        borderRadius: 4,
        },
      ],
    })
  }, [])
  const HorizontalBarChart = () => (
    <>
      <Bar data={data} height={450} options={optionsbar} />
    </>
  )
  return (
    <>
      {loadingDone && (
        <div className="barg-chart">
          <HorizontalBarChart />
        </div>
      )}
    </>
  )
}

export default Chart3
